export class FailedToGetMappingsError {

};
